import Vue from "vue";
import VueRouter from "vue-router";
/* import Register from '../src/components/register'
import RegisterStep1 from '../src/components/register-step1'
import RegisterStep2 from '../src/components/register-step2'
import PasswordReset from '../src/components/password-reset'
import Signin from '../src/components/signin' */
import SATs from '../src/components/SATs'
import AssessmentStart from '../src/components/assessment-start'
import AssessmentStandard from '../src/components/assessment-standard'
import ActionPlan from '../src/components/actionplan'
import Register from '../src/components/register'
//import RegisterStep1 from '../src/components/register-step1'
//import RegisterStep2 from '../src/components/register-step2'
import PasswordReset from '../src/components/password-reset'
import Signin from '../src/components/signin'
import AccountVerification from '../src/components/account-verification'
import store from './store';
//import PasswordForgot from '../src/components/password-forgot'

Vue.use(VueRouter);
//const parseProps = r => ({ id: parseInt(r.params.id) });

export const privateRoutes = [
  {
    path: '/',
    name: 'SATs',
    component: SATs,
    meta: {
      public:false
    },
    props: route => ({ activeTab: parseInt(route.query.activeTab) || 0 })
  },
  {
    path: '/assessment/start',
    name: 'AssessmentStart',
    component: AssessmentStart,
    meta: {
      public:false
    },
    props: route => ({ satId: parseInt(route.query.satId) })
  },
  {
    path: '/assessment/standard',
    name: 'AssessmentStandard',
    component: AssessmentStandard,
    meta: {
      public:false
    },
    props: route => ({ satId: parseInt(route.query.satId), standardId: parseInt(route.query.standardId) })
  },
  {
    path: '/actionplan',
    name: 'ActionPlan',
    component: ActionPlan,
    meta: {
      public:false
    },
    props: route => ({ satId: parseInt(route.query.satId) })
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

export const publicRoutes = [
  {
    path: "/",
    name: "signin",
    component: Signin,
    meta: {
      breadcrumb: "Account Sign in",
      public:true
    }
  },
  {
    path: "/passwordreset",
    name: "password-reset",
    component: PasswordReset,
    meta: {
      breadcrumb: "Reset password",
      public:true
    }
  },
  {
    path: "/accountverification",
    name: "account-verification",
    component: AccountVerification,
    meta: {
      breadcrumb: "Account verified",
      public:true
    }
  },
  // {
  //   path: '/self-assessment-tools/passwordreset/:id?',
  //   name: 'password-forgot',
  //   component: PasswordForgot,
  //   props: { id: 1}
  // },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      breadcrumb: "Create an account",
      public:true
    }
  },
  // {
  //   path: "/register/:id",
  //   name: "register-step1",
  //   component: RegisterStep1,
  //   props: { id: 1 }
  // },
  // {
  //   path: "/register/:id",
  //   name: "register-step2",
  //   component: RegisterStep2,
  //   props: { id: 2 }
  // }
];

export const privateRouter = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL + "/self-assessment-tools",
  routes: privateRoutes,

 
});

export const publicRouter = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL + "/self-assessment-tools-login",
  routes: publicRoutes,
 
});

publicRouter.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ['/signin', '/register','/password-reset'];
  // const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('user');

  // if (authRequired && !loggedIn) {
  //   return next('/signin');
  // }
  
  store.dispatch('alert/clear');
  
  // Need to sign out user on public pages as we don't want signedin user 
  let signedin =store.state.account.status.signedin;
  if(to.meta.public && signedin)
  store.dispatch('account/signout');
  else if (!to.meta.public && !signedin)
  store.state.account.authenticateUserAction();
  
  window.scrollTo(0,0);
  next();

})

privateRouter.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ['/signin', '/register','/password-reset'];
  // const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('user');

  // if (authRequired && !loggedIn) {
  //   return next('/signin');
  // } 
  
  store.dispatch('alert/clear');
  let signedin =store.state.account.status.signedin;
  if (!to.meta.public && !signedin)
  store.state.account.authenticateUserAction();
 window.scrollTo(0,0);
  next();

})

//export default router
